






























































































































import { Component, Vue } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import DatePickerCalendar from "@/shared/components/date-picker-calendar.vue";
import { validPeriod, rangeDateIsValid } from "@/shared/validators";
import {
  TrafegoService,
  UTM,
  FiltrosMonitorTrafego,
  DescricaoTipoPlano,
  Trafego,
} from "@/services/trafego.service";
import ComboFonte from "./Combos/ComboFonte.vue";
import ComboCampanha from "./Combos/ComboCampanha.vue";
import ComboMidia from "./Combos/ComboMidia.vue";
import ComboContexto from "./Combos/ComboContexto.vue";
import ComboPago from "./Combos/ComboPago.vue";
import ComboPlanos from "./Combos/ComboPlanos.vue";
import { dateTime } from "@/shared/filters";
import Warning from "@/shared/components/warning.vue";
import { moeda } from "@/shared/filters";
import dayjs from "dayjs";

interface ComboItem {
  text: string;
  value: number | null;
}

@Component({
  components: {
    DataTable,
    DatePickerCalendar,
    ComboFonte,
    ComboCampanha,
    ComboMidia,
    ComboContexto,
    ComboPago,
    ComboPlanos,
    Warning,
  },
  filters: { dateTime, moeda },
})
export default class MonitorTrafego extends Vue {
  idConsultor: number | null = null;
  loading = false;
  loadingUTM = false;
  periodoInicial: string | null = null;
  periodoFinal: string | null = null;
  promise: UTM | null = null;
  utmSource: ComboItem[] | null = null;
  utmCampaign: ComboItem[] | null = null;
  utmMedium: ComboItem[] | null = null;
  utmContent: ComboItem[] | null = null;
  nullValue: ComboItem = { text: "", value: null };
  disabled = false;
  auxArray: any[] = [];

  promisePesquisa: Trafego[] | null = null;

  monitor: FiltrosMonitorTrafego = {
    fonte: "",
    campanha: "",
    midia: "",
    contexto: "",
    pago: null,
    tipoPlano: [],
  };

  headers = [
    { value: "idConsultor", text: "IdConsultor" },
    { value: "nome", text: "Nome" },
    { value: "dataContratacao", text: "Dt. Contratação" },
    { value: "utmSource", text: "Fonte" },
    { value: "utmCampaign", text: "Campanha" },
    { value: "utmMedium", text: "Mídia" },
    { value: "utmContent", text: "Contexto" },
    { value: "idTipoPlano", text: "Plano" },
    { value: "valor", text: "Valor" },
  ];

  rules = {
    periodo: [validPeriod(), rangeDateIsValid(365)],
  };

  mounted() {
    this.iniciaFiltro();
  }

  iniciaFiltro() {
    const dataInicio = dayjs()
      .subtract(1, "month")
      .startOf("month")
      .format("DD/MM/YYYY");
    const dataFim = dayjs()
      .subtract(1, "month")
      .endOf("month")
      .format("DD/MM/YYYY");
    this.periodoInicial = dataInicio;
    this.periodoFinal = dataFim;
  }

  tipoMensagem(tipo: number) {
    switch (tipo) {
      case 3:
        return "Erro Enviado";
      case 4:
        return "Erro ao Sincronizar";
      default:
        return tipo;
    }
  }

  async carregarCombosTrafego() {
    if (this.periodoInicial && this.periodoFinal) {
      const periodo = this.periodoInicial + " - " + this.periodoFinal;
      this.loadingUTM = true;
      this.promise = await TrafegoService.ListaUTM(periodo).finally(() => {
        this.loadingUTM = false;
      });
      if (this.promise) {
        if (
          this.promise.utmCampaign.length > 0 ||
          this.promise.utmContent.length > 0 ||
          this.promise.utmMedium.length > 0 ||
          this.promise.utmSource.length > 0
        ) {
          this.utmSource = this.promise.utmSource.map((x, i) => ({
            text: x.utmSource,
            value: i,
          }));
          this.utmCampaign = this.promise.utmCampaign.map((x, i) => ({
            text: x.utmCampaign,
            value: i,
          }));
          this.utmMedium = this.promise.utmMedium.map((x, i) => ({
            text: x.utmMedium,
            value: i,
          }));
          this.utmContent = this.promise.utmContent.map((x, i) => ({
            text: x.utmContent,
            value: i,
          }));
          this.utmSource.unshift(this.nullValue);
          this.utmCampaign.unshift(this.nullValue);
          this.utmMedium.unshift(this.nullValue);
          this.utmContent.unshift(this.nullValue);
        } else {
          const modalWarning = this.$refs.warning as Warning;
          const title = "Nenhuma UTM foi encontrada";
          const text = "Selecione outro período.";
          await modalWarning.open(title, text);
        }
      }
    }
  }

  async pesquisar() {
    const periodo = this.periodoInicial + " - " + this.periodoFinal;
    if (
      !this.monitor.fonte &&
      !this.monitor.campanha &&
      !this.monitor.midia &&
      !this.monitor.contexto
    ) {
      const modalWarning = this.$refs.warning as Warning;
      const title = "Nenhuma UTM foi selecionada";
      const text = "Selecione pelo menos uma UTM.";
      await modalWarning.open(title, text);
    } else {
      this.loading = true;
      const ids = this.monitor.tipoPlano.map((x) => x.idTipoPlano);
      const arrayString = ids.join();
      this.promisePesquisa = await TrafegoService.ListarMonitorTrafego(
        this.monitor,
        arrayString,
        periodo
      ).finally(() => {
        this.loading = false;
      });
      if (!this.promisePesquisa) {
        const modalWarning = this.$refs.warning as Warning;
        const title = "Registro não foi encontrado";
        const text = "Não foi possível encontrar a UTM com os dados informados";
        await modalWarning.open(title, text);
      }
    }
  }

  getTipoPlano(status: number) {
    switch (status) {
      case 1:
        return DescricaoTipoPlano["Gratis"];
      case 2:
        return DescricaoTipoPlano["MensalLite"];
      case 3:
        return DescricaoTipoPlano["TrimestralLite"];
      case 5:
        return DescricaoTipoPlano["SemestralLite"];
      case 6:
        return DescricaoTipoPlano["AnualLite"];
      case 7:
        return DescricaoTipoPlano["BonusLite"];
      case 8:
        return DescricaoTipoPlano["Mensal"];
      case 9:
        return DescricaoTipoPlano["Trimestral"];
      case 10:
        return DescricaoTipoPlano["Semestral"];
      case 11:
        return DescricaoTipoPlano["Anual"];
      case 12:
        return DescricaoTipoPlano["Bonus"];
    }
  }

  csvExport() {
    if (this.promisePesquisa) {
      this.auxArray = JSON.parse(JSON.stringify(this.promisePesquisa));
      this.auxArray.forEach(function (v) {
        v.dataContratacao = dayjs(v.dataContratacao).format("DD/MM/YYYY");
        delete v.estadoEntidade;
      });

      let csvContent = "";
      csvContent += [
        this.headers
          .map((item) => item.text)
          .toString()
          .replaceAll(",", ";"),
        ...this.auxArray.map((item) => Object.values(item).join(";")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const BOM = "\uFEFF"; // utf-8 byte-order-mark
      const csvBlob = new Blob([BOM + csvContent], {
        type: "text/csv;charset=utf-8",
      });

      const objectUrl = URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.setAttribute("href", objectUrl);
      a.setAttribute("download", "exampleTable.csv");

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}
